import { Fragment } from 'react';
import InfoCardStudentSpread from './InfoCardStudentSpread';
import { getUnassignedStudents } from '../../helper';
import { Link } from 'react-router-dom';
import DelimitedList from '../atoms/DelimitedList/DelimitedList.js';
import { getAdminInfo } from '../../helper';
import InfoCard from '../molecules/InfoCard';

const ManageHomeLayout = ({ students, homeCatStudents }) => {
  const adminInfo = getAdminInfo();
  let welcomeMsg = '';

  // determine welcome message
  if (Number(adminInfo['admin_level']) === 9) {
    welcomeMsg = (
      <p>
        Welcome,{' '}
        <span data-cy='user-name-text' className='font-bold'>
          {adminInfo['admin_name']}
        </span>
        .
        <br /> You are now logged in as an Administrator.
        <div className='spacer'></div>
        <div>
          New:&nbsp;
          <a
            href='/manage/update-sacrament'
            className='font-bold text-primary-900 hover:text-secondary-300'
          >
            Update Sacraments for Students
          </a>
        </div>
      </p>
    );
  } else if (Number(adminInfo['admin_level']) === 6) {
    welcomeMsg = (
      <p>
        Welcome,{' '}
        <span data-cy='user-name-text' className='font-bold'>
          {adminInfo['admin_name']}
        </span>
        .
        <br /> You are now logged in as a Home Catechist.
      </p>
    );
  }

  const strays = getUnassignedStudents(students);
  const unassignedStudents = strays.map(student => {
    return (
      <Link
        to={`/manage/classes/${student.student_level}`}
        className='duration-300 hover:font-bold hover:text-primary-700'
      >
        Level {student.student_level} - {student.student_first_name}{' '}
        {student.student_last_name}
      </Link>
    );
  });

  let totalStudents = 0;

  return (
    <div className='grid grid-cols-1 justify-between gap-2 md:grid-cols-6 lg:grid-cols-8'>
      <div className='p-4 md:col-span-4 lg:col-span-4'>
        <div className=' text-3xl font-bold'>Welcome!</div>
        <div className='mt-4 text-lg font-light'>
          <div className='my-5'>{welcomeMsg}</div>

          {Number(adminInfo['admin_level']) === 9 && (
            <div className='my-4'>
              {unassignedStudents.length > 0 && (
                <div className='mb-2 font-bold text-rose-700'>
                  You have unassigned students:
                </div>
              )}
              <DelimitedList listItems={unassignedStudents} />
            </div>
          )}
        </div>
      </div>
      {Number(adminInfo['admin_level']) === 9 && (
        <>
          <div className='md:order-first md:col-span-2 lg:col-span-2'>
            <InfoCardStudentSpread />
          </div>

          <div className='md:col-span-6 lg:col-span-2'>
            <InfoCard cardTitle='Homecat Distribution'>
              {homeCatStudents ? (
                <div className=' grid grid-cols-2 gap-2'>
                  {homeCatStudents?.map((spread, index) => {
                    totalStudents += Number(spread.count);
                    return (
                      <Fragment key={index}>
                        <div>Level {spread.level}</div>
                        <div>{spread.count}</div>
                      </Fragment>
                    );
                  })}
                </div>
              ) : (
                <div>
                  {/* <Skeleton variant='text' />
                  <Skeleton variant='text' />
                  <Skeleton variant='text' />
                  <Skeleton variant='text' />
                  <Skeleton variant='text' />
                  <Skeleton variant='text' />
                  <Skeleton variant='text' />
                  <Skeleton variant='text' />
                  <Skeleton variant='text' />
                  <Skeleton variant='text' /> */}
                  loading...
                </div>
              )}
            </InfoCard>
          </div>
        </>
      )}
    </div>
  );
};

export default ManageHomeLayout;
